import React from 'react';

const StudioKohlerSmallLogo = /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "120", height: "15", viewBox: "0 0 120 15", fill: "none", "aria-label": "Studio Kohler Logo" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.8043 0.389999C65.968 0.389999 62.8674 3.4753 62.8674 7.26884C62.8674 11.0705 65.9763 14.1477 69.8098 14.1477C73.6434 14.1477 76.7467 11.0597 76.7467 7.26341C76.7439 3.46445 73.6351 0.389999 69.8043 0.389999ZM72.9296 7.26067C72.9296 9.13302 71.53 10.6499 69.8068 10.6499C68.0864 10.6526 66.6841 9.13844 66.6841 7.26338C66.6814 5.39647 68.0837 3.87959 69.8041 3.87959C71.5328 3.87688 72.9296 5.39375 72.9296 7.26067Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M1.29015 9.64316C1.23206 12.3621 3.21522 13.1952 5.68518 13.1952C7.09856 13.1952 9.25043 12.4354 9.25043 10.5115C9.25043 9.01362 7.74025 8.41935 6.47899 8.12357L3.48075 7.40177C1.89588 7.01374 0.44378 6.29193 0.44378 4.21878C0.44378 2.92442 1.29291 0.498513 5.08497 0.498513C7.76237 0.498513 10.0636 1.88513 10.0636 4.60682H8.78023C8.68619 2.60694 7.02664 1.57308 5.10157 1.57308C3.34798 1.57308 1.7244 2.24061 1.7244 4.19979C1.7244 5.43988 2.64821 5.97716 3.7601 6.21595L7.04324 7.01102C8.94895 7.51031 10.5338 8.34337 10.5338 10.4898C10.5338 11.3961 10.1576 14.2643 5.38369 14.2643C2.19737 14.2643 -0.142593 12.8587 0.00676619 9.63773H1.29015V9.64316Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M14.193 4.44402H16.1734V5.42361H14.193V11.8629C14.193 12.6226 14.3064 13.065 15.1555 13.1219C15.4957 13.1219 15.8359 13.1029 16.1734 13.065V14.0635C15.9936 14.0635 15.8193 14.073 15.6451 14.0825C15.4708 14.092 15.2966 14.1015 15.1168 14.1015C13.5319 14.1015 12.9843 13.5832 13.0036 11.9551V5.42361H11.3054V4.44402H13.0036V1.5758H14.193V4.44402Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M24.261 13.993H25.3563V4.44401H24.167V9.45593C24.167 11.3988 23.2819 13.2875 21.2434 13.2875C19.3571 13.2875 18.696 12.3811 18.6407 10.6607V4.44401H17.4514V10.6445C17.4514 12.8858 18.3945 14.2725 20.8645 14.2725C22.3166 14.2725 23.6 13.5507 24.2223 12.2726H24.261V13.993Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.2761 13.993H35.3714V0.780721H34.1821V6.25937H34.1433C33.651 4.88903 32.1989 4.16723 30.7662 4.16723C27.8039 4.16723 26.3905 6.49816 26.3905 9.21985C26.3905 11.9415 27.8039 14.2725 30.7662 14.2725C32.1823 14.2725 33.7285 13.4394 34.2374 12.1803H34.2761V13.993ZM34.1818 9.21717C34.1818 11.1953 33.2774 13.2875 30.7687 13.2875C28.5062 13.2875 27.5824 11.1953 27.5824 9.21717C27.5824 7.239 28.5062 5.14685 30.7687 5.14685C33.2774 5.14685 34.1818 7.239 34.1818 9.21717Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ React.createElement("path", { d: "M37.2389 0.780721H38.4283V2.65035H37.2389V0.780721Z", fill: "currentColor" }), /* @__PURE__ */ React.createElement("path", { d: "M37.2389 4.44401H38.4283V13.993H37.2389V4.44401Z", fill: "currentColor" }), /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.4051 14.2698C47.3674 14.2698 49.0076 11.9551 49.0076 9.21713C49.0076 6.47917 47.3674 4.16451 44.4051 4.16451C41.4428 4.16451 39.8027 6.47645 39.8027 9.21713C39.8027 11.9578 41.4428 14.2698 44.4051 14.2698ZM44.4053 13.2874C42.1428 13.2874 40.9922 11.2333 40.9922 9.2171C40.9922 7.20093 42.1428 5.14678 44.4053 5.14678C46.6678 5.14678 47.8185 7.20093 47.8185 9.2171C47.8185 11.2333 46.6678 13.2874 44.4053 13.2874Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ React.createElement("path", { d: "M89.3319 0.769871L89.3374 13.9686L97.1428 13.9658V10.5902H93.0188L93.0133 0.767157L89.3319 0.769871Z", fill: "currentColor" }), /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M77.3607 13.974L77.3497 0.775323L81.0283 0.772609L81.0311 5.40463L84.7374 5.3992L84.7347 0.772609L88.4133 0.769896L88.4189 13.9686H84.743V9.05978L81.0311 9.0652L81.0366 13.9713L77.3607 13.974Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M59.5483 7.07346L64.8561 0.783463H60.0904L56.6164 4.70856V0.783463L52.9405 0.786177L52.9461 13.9849H56.6192L56.6164 9.27957H56.6247L60.7542 13.9849H65.6222L59.5483 7.07346Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M105.357 0.759042L101.579 0.767182H97.8921L97.9004 13.9659L105.399 13.9604L105.393 10.8616L101.665 10.8643V8.85355L105.07 8.84541L105.067 5.89578H101.654L101.67 3.81178L105.357 3.80093V0.759042Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.839 13.9604L113.008 8.67988C117.455 5.73839 114.88 0.748183 110.823 0.75361L106.215 0.756324L106.223 13.9523L109.821 13.9496V9.9064L112.817 13.9604H116.839ZM112.145 5.08443C112.145 5.78724 111.561 6.35708 110.848 6.35708L109.805 6.35437V3.8172L110.842 3.81449C111.561 3.81449 112.145 4.38162 112.145 5.08443Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.043 14.0011H119.292L118.847 13.3363C119.107 13.3282 119.314 13.2251 119.314 12.9374C119.314 12.6254 119.054 12.5548 118.791 12.5548H118.144L118.147 14.0011H118.352V13.3336H118.601L119.043 14.0011ZM118.667 13.1337C118.855 13.1373 119.106 13.1422 119.106 12.9347C119.104 12.7855 118.905 12.7611 118.744 12.7611H118.351V13.1301C118.351 13.1328 118.6 13.1328 118.6 13.1328C118.621 13.1328 118.644 13.1333 118.667 13.1337Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.295 13.2875C117.295 12.5494 117.892 11.966 118.647 11.966C119.403 11.966 120 12.5494 120 13.2848C120.003 14.0201 119.405 14.6063 118.65 14.6063C117.892 14.6063 117.295 14.0256 117.295 13.2875ZM119.793 13.2848C119.793 12.6661 119.261 12.1695 118.65 12.1695C118.033 12.1695 117.508 12.6661 117.508 13.2875C117.508 13.9089 118.033 14.4027 118.656 14.4027C119.267 14.4 119.793 13.9062 119.793 13.2848Z",
    fill: "currentColor"
  }
));

export { StudioKohlerSmallLogo };
